export default {
  pageTitle: {
    en: "Please check your email and enter code",
    ja: "メールを確認してコードを入力してください"
  },

  buttonText: {
    en: "Confirm",
    ja: "サインアップ"
  },
  forgotPassword: {
    en: "Forgot password?",
    ja: "パスワードをお忘れですか？"
  },
  alreadyRegistered: {
    en: "Already registered?",
    ja: "すでに登録？"
  },
  signIn: {
    en: "Sign in",
    ja: "ログイン"
  },

  Code: {
    en: "One time code",
    ja: "ワンタイムコード"
  },
  passwordLabel: {
    en: "Password",
    ja: "パスワード"
  },
  confirmPasswordLabel: {
    en: "Confirm password",
    ja: "パスワードを認証する"
  }
}
